"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var entries = [{
  gender: "F",
  characterRace: "1ST",
  characterClass: "Cleric",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}, {
  gender: "M",
  characterRace: "Barbarian",
  characterClass: "Warrior",
  level: 34,
  gp: 32
}];
var _default = entries;
exports.default = _default;